import {immerable} from 'immer';
import {register} from 'ol/proj/proj4';
import proj4 from 'proj4';

const DEFAULT_VALUE_ZOOM = {
  zoom: 18,
  height: 400,
  width: 600,
};

export default class MapComponentModel {
  [immerable] = true;

  update(
    obj,
  ) {
    Object.keys(obj).forEach((key) => {
      if (this[key] !== undefined) {
        this[key] = obj[key];
      }
    });
  }

  _zoom;
  get zoom() {
    return this._zoom;
  }
  set zoom(zoom) {
    this._zoom = zoom;
  }

  _minZoom;
  get minZoom() {
    return this._minZoom;
  }
  set minZoom(minZoom) {
    this._minZoom = minZoom;
  }

  _maxZoom;
  get maxZoom() {
    return this._maxZoom;
  }
  set maxZoom(maxZoom) {
    this._maxZoom = maxZoom;
  }

  _center;
  get center() {
    return this._center;
  }
  set center(center) {
    this._center = center;
  }

  _projection;
  get projection() {
    return this._projection;
  }
  set projection(projection) {
    this._projection = projection;
  }

  _options;
  get options() {
    return this._options;
  }
  set options(options) {
    this._options = options;
  }

  _maps = [];
  get maps() {
    return this._maps;
  }
  set maps(maps) {
    this._maps = maps;
  }

  _minimapMaps = [];
  get minimapMaps() {
    return this._minimapMaps;
  }
  set minimapMaps(minimapMaps) {
    this._minimapMaps = minimapMaps;
  }

  _overMaps = [];
  get overMaps() {
    return this._overMaps;
  }
  set overMaps(overMaps) {
    this._overMaps = overMaps;
  }

  _layersGroup = [];
  get layersGroup() {
    return this._layersGroup;
  }
  set layersGroup(layersGroup) {
    this._layersGroup = layersGroup;
  }

  _positionMouse = [];
  get positionMouse() {
    return this._positionMouse;
  }
  set positionMouse(positionMouse) {
    this._positionMouse = positionMouse;
  }

  _maxSizePolygonRequest = [];
  get maxSizePolygonRequest() {
    return this._maxSizePolygonRequest;
  }
  set maxSizePolygonRequest(maxSizePolygonRequest) {
    this._maxSizePolygonRequest = maxSizePolygonRequest;
  }

  _warningSizePolygonRequest = [];
  get warningSizePolygonRequest() {
    return this._warningSizePolygonRequest;
  }
  set warningSizePolygonRequest(warningSizePolygonRequest) {
    this._warningSizePolygonRequest = warningSizePolygonRequest;
  }

  _pdf = DEFAULT_VALUE_ZOOM;
  get pdf() {
    return this._pdf;
  }
  set pdf(pdf) {
    this._pdf = pdf;
  }

  _coordinatesSystem = [];
  get coordinatesSystem() {
    return this._coordinatesSystem;
  }
  set coordinatesSystem(coordinatesSystem) {
    coordinatesSystem.forEach(({name, projection}) => {
      proj4.defs(
        name,
        projection,
      );
      register(proj4);
    });
    this._coordinatesSystem = coordinatesSystem;
  }

  constructor(data) {
    const {
      options = {},
      zoom = 5,
      minZoom = 0,
      maxZoom = 20,
      center = [0, 0],
      projection = 'EPSG:3857',
      maps = [],
      minimapMaps = [],
      overMaps = [],
      layersGroup = [],
      positionMouse = [0, 0],
      maxSizePolygonRequest = null,
      warningSizePolygonRequest = null,
      pdf = DEFAULT_VALUE_ZOOM,
      coordinatesSystem = [],
    } = data;
    this.options = options;
    this.zoom = zoom;
    this.minZoom = minZoom;
    this.maxZoom = maxZoom;
    this.center = center;
    this.projection = projection;
    this.maps = maps;
    this.minimapMaps = minimapMaps;
    this.overMaps = overMaps;
    this.layersGroup = layersGroup;
    this.positionMouse = positionMouse;
    this.maxSizePolygonRequest = maxSizePolygonRequest;
    this.warningSizePolygonRequest = warningSizePolygonRequest;
    this.pdf = pdf;
    this.coordinatesSystem = coordinatesSystem;
  }
}
